/**
 * PDP accordion modal (mobile only)
 * Necessary JS only.
 */
(function () {
  function initOne(modalRoot) {
    if (modalRoot.getAttribute('data-pdp-init') === '1') return;
    modalRoot.setAttribute('data-pdp-init', '1');

    var section = modalRoot.closest('[id^="shopify-section-"]') || document;
    var modal = modalRoot.querySelector('.pdp-accordion-modal-container');
    var panel = modalRoot.querySelector('.pdp-accordion-modal');
    var tabsBox = modalRoot.querySelector('[data-pdp-accordion-tabs]');
    var contentBox = modalRoot.querySelector('[data-pdp-accordion-content]');
    if (!modal || !panel || !tabsBox || !contentBox) return;

    var accordions = Array.prototype.slice.call(
      section.querySelectorAll('.pdp-accordions-wrapper details.bundle-accordion')
    );
    if (!accordions.length) return;

    var prevOverflow = '';
    function isMobile() {
      return window.innerWidth <= 749;
    }
    function lockBody() {
      prevOverflow = document.body.style.overflow || '';
      document.body.style.overflow = 'hidden';
      document.body.classList.add('pdp-accordion-modal-open');
    }
    function unlockBody() {
      if (document.body.classList.contains('pdp-hotspot-drawer-open')) return;
      document.body.style.overflow = prevOverflow;
      document.body.classList.remove('pdp-accordion-modal-open');
    }

    // Build tabs + panes once
    accordions.forEach(function (detailsEl, i) {
      var titleEl = detailsEl.querySelector('.bundle-accordion__title');
      var title = titleEl ? (titleEl.textContent || '').trim() : '';
      if (!title) title = 'Tab ' + (i + 1);

      var tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'pdp-accordion-modal__tab';
      tab.textContent = title;
      tab.setAttribute('data-index', String(i));
      tabsBox.appendChild(tab);

      var pane = document.createElement('div');
      pane.className = 'pdp-accordion-modal__tab-content';
      pane.setAttribute('data-index', String(i));

      var inner = detailsEl.querySelector('.bundle-accordion__content-inner');
      if (inner) {
        var clone = inner.cloneNode(true);
        Array.prototype.slice.call(clone.querySelectorAll('[id]')).forEach(function (el) {
          el.removeAttribute('id');
        });
        var padded = document.createElement('div');
        padded.className = 'pdp-accordion-modal__padded';
        padded.appendChild(clone);
        pane.appendChild(padded);
      }

      contentBox.appendChild(pane);
    });

    var tabs = Array.prototype.slice.call(tabsBox.querySelectorAll('.pdp-accordion-modal__tab'));
    var panes = Array.prototype.slice.call(contentBox.querySelectorAll('.pdp-accordion-modal__tab-content'));

    function initSliders(root) {
      Array.prototype.slice.call(root.querySelectorAll('slider-component')).forEach(function (sc) {
        if (sc && typeof sc.initializeSlider === 'function') sc.initializeSlider();
        else sc.dispatchEvent(new CustomEvent('initSlider', { bubbles: true }));
      });
    }

    function setActive(i) {
      if (i < 0) i = 0;
      if (i > tabs.length - 1) i = tabs.length - 1;
      tabs.forEach(function (t, idx) {
        t.classList.toggle('active', idx === i);
      });
      panes.forEach(function (p, idx) {
        p.classList.toggle('active', idx === i);
      });
      if (panes[i]) initSliders(panes[i]);
    }

    function openModal(i) {
      if (!isMobile()) return;
      accordions.forEach(function (d) {
        d.open = false;
      });
      setActive(i);

      var wasOpen = modal.hasAttribute('open');
      if (!wasOpen) {
        modal.setAttribute('open', '');
        lockBody();
      }

      modal.classList.remove('is-visible');
      panel.offsetHeight;
      requestAnimationFrame(function () {
        modal.classList.add('is-visible');
      });
    }

    function closeModal() {
      if (!modal.hasAttribute('open')) return;
      modal.classList.remove('is-visible');
      unlockBody();
      setTimeout(function () {
        modal.removeAttribute('open');
      }, 450);
    }

    // Open from accordion title
    section.addEventListener('click', function (e) {
      var summary = e.target.closest('.pdp-accordions-wrapper summary.bundle-accordion__summary');
      if (!summary || !isMobile()) return;
      e.preventDefault();
      e.stopPropagation();
      var details = summary.closest('details.bundle-accordion');
      var i = accordions.indexOf(details);
      openModal(i >= 0 ? i : 0);
    });

    // Tabs
    tabsBox.addEventListener('click', function (e) {
      var tab = e.target.closest('.pdp-accordion-modal__tab');
      if (!tab) return;
      setActive(Number(tab.getAttribute('data-index') || 0));
    });

    // Close actions
    var overlay = modalRoot.querySelector('[data-pdp-accordion-overlay]');
    var closeBtn = modalRoot.querySelector('[data-pdp-accordion-modal-close]');
    if (overlay) overlay.addEventListener('click', closeModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    setActive(0);
  }

  function initAll() {
    Array.prototype.slice
      .call(document.querySelectorAll('[data-pdp-accordion-modal-root]'))
      .forEach(initOne);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();

